module.exports = __webpack_public_path__ + "animated_demo.svg?8165f0a49e3e67129ad5e9581bbeeb91";